import script from "./ConfirmarMembresia.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmarMembresia.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmarMembresia.vue?vue&type=style&index=0&id=1a7a0764&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a7a0764"]])

export default __exports__